import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ImportCatalogPage = lazy(() => import('~/features/onboarding/pages/import-catalog-screen'));

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/import-catalog',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ImportCatalogPage />
    </Suspense>
  ),
});
